// extracted by mini-css-extract-plugin
module.exports = {"levelBadge":"ExamTable_levelBadge__ygd1g","levelBadgeText":"ExamTable_levelBadgeText__U44jR","descriptionText":"ExamTable_descriptionText__vG1tI"};